/**
 * Application settings and other constants
 */
export class AppSettings
{

	/**
	 * These are based on the Tailwind screen sizes.
	 * Update tailwind.config.js if you need to modify these numbers
	 * @type {{xs: number, sm: number, md: number, lg: number, xl: number, '2xl': number}}
	 */
	static SCREENS = {
		'xs': 475,
		'sm': 640,
		'md': 768,
		'lg': 1280,
		'xl': 1440,
		'2xl': 1920
	}
}